import React from "react";
import { Wrapper } from "./styled";

export const DropdownContainer = ({ children, ...rest }) => {
  return <Wrapper {...rest}>{children}</Wrapper>;
};
